import { initSentry, Sentry } from "channelwill-sentry-sdk"

import { isShopifyEnv } from "@/utils/env-helper"

const SentryInit = () => {
  // 初始化 Sentry
  initSentry({
    // 必填：Sentry 项目 DSN，用于标识错误上报的目标项目，下面有讲解获取的方法
    dsn: import.meta.env.VITE_SENTRY_DSN,
    ignoreDev: true,
  })

  // Sentry.setExtra('project_platform', {
  //   isShopifyEnv,
  //   shopifyShop,
  //   platformName,
  //   isShopifyAuthorization,
  // })

  // Sentry.setExtra('project_config', {
  //   appOrigin,
  //   apiUrl,
  //   shopifyApiKey,
  //   shopId,
  //   env,
  //   shopifyRedirectPath,
  // })

  // 使用 Shopify Web Vitals API 监控性能（仅 Shopify 环境）
  // https://shopify.dev/docs/api/app-home/apis/web-vitals
  if (
    isShopifyEnv &&
    typeof window !== "undefined" &&
    window.shopify?.webVitals?.onReport
  ) {
    const CLS_THRESHOLD = 0.1
    const LCP_THRESHOLD_MS = 2500
    window.shopify.webVitals
      .onReport(
        (report: {
          metrics: Array<{ id: string; name: string; value: number }>
        }) => {
          const { metrics } = report ?? {}
          if (!Array.isArray(metrics)) return
          console.log("metrics", metrics)
          for (const m of metrics) {
            if (m.name === "CLS" && m.value > CLS_THRESHOLD) {
              const error = new Error(
                `CLS exceeded threshold: ${m.value.toFixed(4)}`,
              )
              console.warn(`CLS exceeded threshold: ${m.value.toFixed(4)}`)
              error.name = "CLSThresholdExceeded"
              Sentry.captureException(error, {
                tags: { type: "web_vital", metric: "CLS" },
                extra: {
                  clsValue: m.value.toFixed(4),
                  threshold: CLS_THRESHOLD,
                  metricId: m.id,
                },
                level: "warning",
              })
            }
            if (m.name === "LCP" && m.value > LCP_THRESHOLD_MS) {
              const error = new Error(
                `LCP exceeded threshold: ${(m.value / 1000).toFixed(2)}s`,
              )
              console.warn(
                `LCP exceeded threshold: ${(m.value / 1000).toFixed(2)}s`,
              )
              error.name = "LCPThresholdExceeded"
              Sentry.captureException(error, {
                tags: { type: "web_vital", metric: "LCP" },
                extra: {
                  lcpMs: Math.round(m.value),
                  lcpSeconds: (m.value / 1000).toFixed(2),
                  thresholdMs: LCP_THRESHOLD_MS,
                  metricId: m.id,
                },
                level: "warning",
              })
            }
          }
        },
      )
      .catch((e: unknown) => {
        console.warn("Shopify webVitals.onReport failed:", e)
      })
  }
}

export default SentryInit
